"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_input_1 = require("../input/awsui-input");
var awsui_select_1 = require("../select/awsui-select");
var awsui_button_1 = require("../button/awsui-button");
var awsui_modal_1 = require("../modal/awsui-modal");
var awsui_table_1 = require("../table/awsui-table");
var awsui_alert_1 = require("../alert/awsui-alert");
var S3InContextWrapper = /** @class */ (function (_super) {
    __extends(S3InContextWrapper, _super);
    function S3InContextWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    S3InContextWrapper.prototype.findUriInput = function () {
        return this.findComponent('.awsui-s3-in-context-fields__uri awsui-input', awsui_input_1.default);
    };
    S3InContextWrapper.prototype.findVersionsSelect = function () {
        return this.findComponent('.awsui-s3-in-context-fields__version awsui-select', awsui_select_1.default);
    };
    S3InContextWrapper.prototype.findViewButton = function () {
        return this.findComponent('.awsui-s3-in-context-fields__view', awsui_button_1.default);
    };
    S3InContextWrapper.prototype.findBrowseButton = function () {
        return this.findComponent('.awsui-s3-in-context-fields__browse', awsui_button_1.default);
    };
    S3InContextWrapper.prototype.findAlert = function () {
        return this.findComponent('.awsui-s3-in-context__alert', awsui_alert_1.default);
    };
    return S3InContextWrapper;
}(dom_1.ElementWrapper));
exports.S3InContextWrapper = S3InContextWrapper;
var S3ResourceSelectorWrapper = /** @class */ (function (_super) {
    __extends(S3ResourceSelectorWrapper, _super);
    function S3ResourceSelectorWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    S3ResourceSelectorWrapper.prototype.findInContext = function () {
        return new S3InContextWrapper(this.find('awsui-s3-in-context').getElement());
    };
    S3ResourceSelectorWrapper.prototype.findModal = function () {
        return this.findComponent('.awsui-s3-modal', awsui_modal_1.default);
    };
    S3ResourceSelectorWrapper.prototype.findTable = function () {
        return this.findComponent('.awsui-s3-selection', awsui_table_1.default);
    };
    return S3ResourceSelectorWrapper;
}(dom_1.ElementWrapper));
exports.default = S3ResourceSelectorWrapper;
//# sourceMappingURL=awsui-s3-resource-selector.js.map